import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './_styles.scss'
import { Button } from '../../../../../packages/components'
import Device from '../../../../../devices/device'
import Utils from '../../../../../utils/Utils'
import { getPhase2Config } from '../../../utils'

class Submenu extends Component {

  constructor(props) {
    super(props)
    this.keys = Device.getDevice().getKeys()
    this.containerRef = null
    this.isPhase2Enabled = getPhase2Config()
  }

  componentDidMount() {
    
    setTimeout(() => {
     const { tabs, activeTab } = this.props
      const children = this.containerRef && this.containerRef.children
      if (!children || !tabs || !tabs.length) return

      const activeIndex = tabs.findIndex(tab => tab.id === activeTab)
      const targetIndex = activeIndex >= 0 ? activeIndex : 0
      const target = children[targetIndex]
      target && target.focus()
    }, 0);
  }

  handleContainerFocus = (e) => {
    const { tabs, activeTab } = this.props
    const children = this.containerRef && this.containerRef.children
    if (!children || !tabs || !tabs.length) return

    // Solo enfocar si el foco viene de fuera del contenedor
    if (!this.containerRef.contains(e.relatedTarget)) {
      const activeIndex = tabs.findIndex(tab => tab.id === activeTab)
      const targetIndex = activeIndex >= 0 ? activeIndex : 0
      const target = children[targetIndex]
      target && target.focus()
    }
  }

  goToChevron = (currentIndex) => {
    const selector = currentIndex < 1 ? 
      '.partidos__chevron-phase1--left .focusable' : 
      '.partidos__chevron-phase1--right .focusable'
    const chevronEl = document.querySelector(selector)
    if (chevronEl) chevronEl.focus()
  }

  handleKeyDown = (tabId) => (e) => {
    const { infinite, tabs, onNavigate, enableKeyboardNavigation } = this.props
    if (!tabs || !tabs.length) return

    const currentKey = this.keys.getPressKey(e.keyCode)
    if (currentKey !== 'LEFT' && currentKey !== 'RIGHT') return

    e.preventDefault()
    e.stopPropagation()

    const currentIndex = tabs.findIndex(tab => tab.id === tabId)
    const children = this.containerRef && this.containerRef.children
    if (!children) return

    let targetIndex = currentIndex

    if (currentKey === 'LEFT') {
      if (currentIndex === 0) {
        if (infinite) {
          targetIndex = tabs.length - 1
        } else {
          return !this.isPhase2Enabled ? 
            this.goToChevron(currentIndex) : false
        }
      } else {
        targetIndex = currentIndex - 1
      }
    } else if (currentKey === 'RIGHT') {
      if (currentIndex === tabs.length - 1) {
        if (infinite) {
          targetIndex = 0
        } else {
          return !this.isPhase2Enabled ? 
            this.goToChevron(currentIndex) : false
        }
      } else {
        targetIndex = currentIndex + 1
      }
    }

    children[targetIndex].focus()
    
    // Solo ejecutar onNavigate si está habilitada la navegación por teclado
    if (enableKeyboardNavigation) {
      // Calcular steps como la diferencia entre índices (igual que en handleClick)
      const steps = targetIndex - currentIndex
      onNavigate && onNavigate(steps)
    }

    return false
  }

  handleClick = (idTab) => {
    const { onNavigate, enableKeyboardNavigation } = this.props

    // Si no está habilitada la navegación por teclado, usar navegación por click
    // if (!enableKeyboardNavigation) {
      const currentIndex = this.props.tabs.findIndex(tab => tab.id === this.props.activeTab)
      const newIndex = this.props.tabs.findIndex(tab => tab.id === idTab)
      const steps = newIndex - currentIndex

      onNavigate && onNavigate(steps)
    // }
  }

  render () {
    const { tabs, activeTab, classNames, getActiveLabel, itemDataOptions, maxCaracters } = this.props

    return (
      <div
        ref={(el) => { this.containerRef = el }}
        className='submenu'
        onFocus={this.handleContainerFocus}
      >
        {tabs && tabs.map((tab) => {
          const isActive = tab.id === activeTab
          const label = isActive && getActiveLabel ? getActiveLabel(tab) : maxCaracters ? Utils.cutPlayerString(tab.label, maxCaracters) : tab.label

          return (
            <Button
              key={tab.id}
              className={`focusable submenu__tab ${classNames.tab} ${isActive ? classNames.active : ''} submenu__tab--focused`}
              dataOptions={itemDataOptions}
              onClick={() => this.handleClick(tab.id)}
              onKeyDown={this.handleKeyDown(tab.id)}
            >
              <span className='submenu__tab-label'>{label}</span>
            </Button>
          )
        })}
      </div>
    )
  }
}

Submenu.propTypes = {
  /** Lista de tabs a renderizar */
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  /** id del tab actualmente activo */
  activeTab: PropTypes.string,
  /** Callback de navegación: recibe steps (-1 para LEFT, +1 para RIGHT). Se ejecuta según enableKeyboardNavigation */
  onNavigate: PropTypes.func,
  /** Si es true, navega con flechas LEFT/RIGHT. Si es false (default), navega con click/OK */
  enableKeyboardNavigation: PropTypes.bool,
  /** Función opcional para obtener la etiqueta del tab activo. Recibe el tab y retorna string */
  getActiveLabel: PropTypes.func,
  /** dataOptions pasado a cada Button (e.g. { 'data-sn-down': '...' }) */
  itemDataOptions: PropTypes.object,
  /** Si es true, el foco hace wrap al primer/último elemento al llegar a los extremos */
  infinite: PropTypes.bool,
  /** Clases CSS para los distintos estados del tab */
  classNames: PropTypes.shape({
    /** Clase base aplicada a todos los tabs */
    tab: PropTypes.string,
    /** Clase del tab activo cuando el contenedor NO tiene foco */
    active: PropTypes.string,
    /** Clase del tab activo cuando el contenedor SÍ tiene foco */
    activeContainerFocused: PropTypes.string
  })
}

Submenu.defaultProps = {
  activeTab: null,
  onNavigate: null,
  enableKeyboardNavigation: false,
  getActiveLabel: null,
  infinite: false,
  itemDataOptions: {},
  classNames: {
    tab: '',
    active: '',
    activeContainerFocused: ''
  }
}

export default Submenu
 


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/SubmenuFases/index.jsx